import * as React from 'react';
import { Stack, type StackProps } from '@mui/material';

// Default Styling:
// margin-top & margin-bottom: 0.5rem, flex:direction: row, align: flex-start, spacing: 2

// Default Behavior:
// "margin" should be managed by parent component
// "spacing" between children component should also be managed by parent component

export const ButtonContainer: React.FunctionComponent<StackProps> = (
  props: StackProps,
) => {
  const { children, ...rest } = props;

  return (
    <Stack direction="row" alignItems="flex-start" {...rest}>
      {children}
    </Stack>
  );
};
